import {
  currencyFormFieldFormatter,
  currencySubmitVariableFormatter,
} from 'app/shared/utils/currencyFormatter';
import { get, getInteger } from 'app/shared/utils/get';

export const errorMsgForField = (field: string, touched: any, errors: any) =>
  get(touched, field, undefined) && get(errors, field, undefined)
    ? get(errors, field, undefined)
    : null;

export const refocusToFirstError = (errors: any, isSubmitting: boolean) => {
  const keys = Object.keys(errors);
  if (keys.length > 0 && isSubmitting) {
    const findFirstErrorElementName = (
      scopedErrors: any,
      prefix = ''
    ): string => {
      for (const key of Object.keys(scopedErrors)) {
        const value = scopedErrors[key];
        if (value == null) {
          continue;
        }
        const path = prefix ? `${prefix}.${key}` : key;
        if (typeof value === 'string') {
          return path;
        }
        const nested = findFirstErrorElementName(value, path);
        if (nested) {
          return nested;
        }
      }
      return '';
    };

    const firstErrorElementName = findFirstErrorElementName(errors);
    const errorElement: HTMLElement | null =
      document.querySelector(`label[for="${firstErrorElementName}"]`) ||
      document.querySelector(`[name="${firstErrorElementName}"]`) ||
      document.querySelector(
        `[data-name-for-error="${firstErrorElementName}"]`
      );
    if (errorElement) {
      errorElement.scrollIntoView && errorElement.scrollIntoView();
      errorElement.focus();
    }
  }
};

interface ObjectWithId {
  id: string | number;
  [key: string]: any;
}
export const getIdsFormInitialValue = (items: ObjectWithId[] | undefined) =>
  items?.map((obj) => Number(obj.id)) || [];

export const getCurrencyFormInitialValue = (
  data: any,
  path: string,
  currencyCode?: string
) => {
  const valueFromProps = getInteger(data, path, undefined);

  return valueFromProps || valueFromProps == 0
    ? currencyFormFieldFormatter({
        value: valueFromProps,
        currencyCode,
      })
    : '';
};

export const getCurrencyRoundedFormInitialValue = (
  data: any,
  path: string,
  currencyCode?: string
) => {
  const valueFromProps = getInteger(data, path, undefined);

  return valueFromProps || valueFromProps == 0
    ? currencyFormFieldFormatter({
        value: valueFromProps,
        currencyCode,
        onlyMajorUnits: true,
      })
    : '';
};

export const getCurrencySubmitVariable = (
  value: number | string | null | undefined,
  defaultValue?: number | null,
  currencyCode?: string
) =>
  value
    ? currencySubmitVariableFormatter({
        value: value ? String(value) : '',
        currencyCode,
      })
    : defaultValue || defaultValue == 0
      ? defaultValue
      : null;

export const getNumberInitialValue = (data: any, path: string) => {
  const valueFromProps = getInteger(data, path, undefined);

  return valueFromProps || valueFromProps == 0 ? valueFromProps.toString() : '';
};

export const getNumberSubmitVariable = (value: string | null | undefined) =>
  value ? Number(value) : null;

export const getIdsSubmitVariable = (ids: number[] | undefined) =>
  ids && ids.length > 0
    ? ids.map((id: number) => String(id)).join(',')
    : undefined;

// Returns a string containing percentage value with two decimal points e.g. '56.83' or '30.00'
export const getPercentageDecimalFormInitialValue = (
  data: any,
  path: string
) => {
  const valueFromProps = getInteger(data, path, undefined);

  return valueFromProps || valueFromProps == 0
    ? (Number(valueFromProps) / 100).toFixed(2)
    : '';
};

// Returns an integer representing hundredths of a percent, e.g. 5683 meaning 56.83% or 3000 meaning 30%
export const getPercentageDecimalSubmitVariable = (
  value: string | undefined,
  defaultValue?: number | null
) =>
  value
    ? Math.floor(Number(value) * 100)
    : defaultValue || defaultValue == 0
      ? defaultValue
      : null;
